import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { Globals } from '../../globals';
import { HttpParams, HttpClient } from '@angular/common/http';
import * as moment from 'moment';

interface Income {
    UID: string;
    UID_RESTAURANT: string;
    concept: string;
    number: string;
    date: string;
    base: number;
    tax: number;
    total: number;
    payment_method: string;

}

interface Expenses {
    UID: string;
    UID_RESTAURANT: string;
    concept: string;
    number: string;
    date: string;
    base: number;
    tax: number;
    total: number;
    business_name: string;
    payment_method: string;
    provider_uid?: string;
    category?: string;
    payment?: boolean;
    irpf_percentage?: number;
    irpf_amount?: number;

}

@Injectable()
export class IncomeExpensesServices {
    private firestore: any;

    incomeDoc: AngularFirestoreDocument<Income>;
    incomeCol: AngularFirestoreCollection<Income>;
    incomes: any;

    expensesDoc: AngularFirestoreDocument<Expenses>;
    expensesCol: AngularFirestoreCollection<Expenses>;
    expenses: Observable<Expenses[]>;

    page_active: number = 1;
    limit_pages: number;


    constructor(public afs: AngularFirestore,
        public globals: Globals,
        public http: HttpClient,) {
        this.firestore = firebase.firestore();
    }

    async getListIncome(UID_RESTAURANT, _date_first, _date_last) {
        this.incomeCol = this.afs.collection('income', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .orderBy('date', 'desc'));
        this.incomes = this.incomeCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Income;
                data.UID = a.payload.doc.id;

                return data;
            });
        });
    }

    getListExpenses(UID_RESTAURANT) {
        this.expensesCol = this.afs.collection('expenses', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('date', 'desc'));
        this.expenses = this.expensesCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Expenses;
                data.UID = a.payload.doc.id;
                // Asegurar que IRPF esté siempre inicializado
                if (data.irpf_percentage === null || data.irpf_percentage === undefined) {
                    data.irpf_percentage = 0;
                }
                if (data.irpf_amount === null || data.irpf_amount === undefined) {
                    data.irpf_amount = 0;
                }
                return data;
            });
        });
    }

    async getIncomes(UID_RESTAURANT) {
        const incomeRef = this.firestore.collection('income');
        var incomes = [];

        await incomeRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var income = doc.data();
                    income.UID = doc.id;
                    incomes.push(income);

                });
            });
        return incomes;
    }

    async getExpenses(UID_RESTAURANT) {
        const expensesRef = this.firestore.collection('expenses');
        var expenses = [];

        await expensesRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var expense = doc.data();
                    expense.UID = doc.id;
                    // Asegurar que IRPF esté siempre inicializado
                    if (expense.irpf_percentage === null || expense.irpf_percentage === undefined) {
                        expense.irpf_percentage = 0;
                    }
                    if (expense.irpf_amount === null || expense.irpf_amount === undefined) {
                        expense.irpf_amount = 0;
                    }
                    expenses.push(expense);
                });
            });
        return expenses;
    }

    async getIncomeExpensesBetweenDates(UID_RESTAURANT, _date_first, _date_last) {
        //init
        var date_first = firebase.firestore.Timestamp.fromDate(new Date(_date_first));
        var date_last = firebase.firestore.Timestamp.fromDate(new Date(_date_last));
        var return_array = [];
        var incomes = [];
        var expenses = [];
        var total_income = 0;
        var total_income_tax = 0;
        var total_expenses = 0;
        var total_expenses_tax = 0;
        var total_tax = 0;
        var neto = 0;
        //ref firebase
        const incomeRef = this.firestore.collection('income');
        const expensesRef = this.firestore.collection('expenses');

        //recuperamos incomes
        await incomeRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('date', '>=', date_first)
            .where('date', '<=', date_last)
            .orderBy('date', 'desc')
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var income = doc.data();
                    income.UID = doc.id;
                    //push n calculate
                    incomes.push(income);
                    total_income += parseFloat(income.total);
                    total_income_tax += this.globals.taxOfValue(income.base, income.tax);

                });
            });
        //recuperamos expenses
        await expensesRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('date', '>=', date_first)
            .where('date', '<=', date_last)
            .orderBy('date', 'desc')
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var expense = doc.data();
                    expense.UID = doc.id;
                    // Asegurar que IRPF esté siempre inicializado
                    if (expense.irpf_percentage === null || expense.irpf_percentage === undefined) {
                        expense.irpf_percentage = 0;
                    }
                    if (expense.irpf_amount === null || expense.irpf_amount === undefined) {
                        expense.irpf_amount = 0;
                    }
                    //push n calculate
                    expenses.push(expense);
                    total_expenses += parseFloat(expense.total);
                    // Calcular IVA sobre la base original
                    // El IVA se calcula sobre la base original, no sobre la base después de IRPF
                    total_expenses_tax += this.globals.taxOfValue(expense.base, expense.tax);
                });
            });

        //
        neto = total_income - total_expenses;
        total_tax = total_income_tax - total_expenses_tax;
        //unimos en un solo array
        return_array.push(incomes);
        return_array.push(expenses);
        return_array.push(total_income);
        return_array.push(total_expenses);
        return_array.push(neto);
        return_array.push(total_tax);

        return return_array;
    }

    returnDate(date) {
        var _date = new Date(date.seconds * 1000);
        return _date;
    }


    delete(uid, type) {
        if (type == 'income') {
            this.afs.doc('income/' + uid).delete();
        } else {
            this.afs.doc('expenses/' + uid).delete();
        }

    }


    filteredIncomesExpensesActive: boolean = false;
    filteredIncomesExpenses: any;
    searchIncomesExpensesNode(value, date_first, date_last, type) {
        if (value.target.value == '' || value.target.value == undefined) {
            this.filteredIncomesExpensesActive = false;
        } else {
            if (value.target.value.length >= 2) {
                const params = new HttpParams()
                    .set('uid', this.globals.restaurant_uid)
                    .set('filter_string', value.target.value.toLowerCase())
                    .set('type', type)
                    .set('start_date', date_first)
                    .set('finish_date', date_last);
                this.http.post(this.globals.analytics_path + 'filter/income_expenses', params, {})
                    .subscribe(async res => {
                        this.filteredIncomesExpenses = res;
                        this.filteredIncomesExpensesActive = true;
                    });
            } else {
                this.filteredIncomesExpensesActive = false;
            }
        }
    }

    get_incomesexpenses_done: boolean = false;
    incomesexpenses_array_tmp: any = [];
    incomesexpenses_array_filtered: any = [];
    list_incomesexpenses_array: any = [];
    incomesexpenses_searchbar_text: string = '';
    async getPagesIncomeExpenses(type, date_first, date_last) {
        this.get_incomesexpenses_done = false;
        this.filteredIncomesExpensesActive = false;
        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('type', type)
            .set('start_date', date_first)
            .set('finish_date', date_last);
        await this.http.post(this.globals.analytics_path + 'paginate/income_expenses', params, {})
            .subscribe(async res => {
                this.incomesexpenses_array_tmp = res['list'];
                if (this.incomesexpenses_array_tmp.length != 0) {
                    this.getListIncomeExpenses();
                } else {
                    this.list_incomesexpenses_array = [];
                    this.incomesexpenses_array_filtered = [];
                    this.get_incomesexpenses_done = true;
                }
            });
    }


    getListIncomeExpenses() {
        this.get_incomesexpenses_done = true;
        this.list_incomesexpenses_array = this.incomesexpenses_array_tmp;
        this.incomesexpenses_array_filtered = this.incomesexpenses_array_tmp;
        this.incomesexpensesSearch(this.incomesexpenses_searchbar_text);
    }

    incomesexpensesSearch(value) {
        if (value) {
            this.incomesexpenses_array_filtered = this.list_incomesexpenses_array.filter(objeto => {
                return this.globals.objectToArray(objeto).some(valor => {
                    if (typeof valor === 'string' || typeof valor === 'number') {
                        // Comparar como string
                        return valor.toString().toLowerCase().includes(value.toLowerCase());
                    } else if (Array.isArray(valor)) {
                        // Buscar en cada elemento del array
                        return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
                    }
                    return false;
                });
            });
        } else {
            this.incomesexpenses_array_filtered = this.list_incomesexpenses_array;
        }
    }

    timestampToDate(date) {
        var _date = new Date();
        if (date.seconds) {
            _date = new Date(date.seconds * 1000);
        } else {
            _date = new Date(date._seconds * 1000);
        }

        return moment(_date).format('YYYY-MM-DD');
    }
}



// WEBPACK FOOTER //
// ./src/pages/income-expenses/services.ts